export default __webpack_public_path__ + "static/media/clock.ca14abab.svg";